angular
    .module('WizApp')
    .constant('EVENT_NAMES', {
        jobDynamicRegisterLightbox: {
            open: 'lightbox:job:dynamic-register:open'
        },
        homeDynamicRegisterLightbox: {
            open: 'lightbox:home:dynamic-register:open'
        },
        eventRegisterLightbox: {
            open: 'lightbox:event:register:open',
            submit: 'lightbox:event:register:submit'
        },
        cookieConsentLightbox: {
            open: 'lightbox:cookie:acceptance:open'
        },
        facebookConnect: {
            start: 'facebook:connect:start',
            success: 'facebook:connect:success',
            missingEmail: 'facebook:connect:missing-email',
            error: 'facebook:connect:error',
            cookieActivator: 'facebook:connect:cookie-activator',
            consentActivated: 'facebook:connect:consent-activated',
        },
        googleConnect: {
            start: 'google:connect:start',
            success: 'google:connect:success',
            error: 'google:connect:error',
            cookieActivator: 'google:connect:cookie-activator',
            consentActivated: 'google:connect:consent-activated',
        },
        personalData: {
            request: 'personal:data:request',
        }
    });
